import { config } from 'config';
import { GeneralApiTagTypes } from 'core/api';
import { attachmentsApi } from 'core/attachments/api';

import { TAttachmentDeleteRequestBody, TAttachmentDeleteResponseBody } from '../types';

const updateAttachmentApi = attachmentsApi.injectEndpoints({
    endpoints: (builder) => ({
        deleteAttachment: builder.mutation<TAttachmentDeleteResponseBody, TAttachmentDeleteRequestBody>({
            query: ({ attachmentId }) => {
                return {
                    url: config.api.endpoints.attachments.delete.replace(':id', attachmentId.toString()),
                    method: 'DELETE',
                };
            },
            invalidatesTags: (_, __, arg) => [
                { type: GeneralApiTagTypes.attachment.item },
                { type: GeneralApiTagTypes.attachment.file, id: arg.attachmentId },
                { type: GeneralApiTagTypes.attachment.list },
                { type: GeneralApiTagTypes.commission.list },
            ],
        }),
    }),
});

export const { useDeleteAttachmentMutation } = updateAttachmentApi;
